import { render, staticRenderFns } from "./HistoricalAnswer.vue?vue&type=template&id=91a3bc0c&scoped=true"
import script from "./HistoricalAnswer.vue?vue&type=script&lang=js"
export * from "./HistoricalAnswer.vue?vue&type=script&lang=js"
import style0 from "./HistoricalAnswer.vue?vue&type=style&index=0&id=91a3bc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a3bc0c",
  null
  
)

export default component.exports